const dateFormats = {
  dateFormatDefault: "DD. MM. YYYY",
  dateFormatCustom: "D. MMMM YYYY",
  dateFormatDayjs: "YYYY-MM-DD",
  dateFormatIso: "YYYY-MM-DDTHH:mm:ssZ",
  dateFormatWeekdayMonth: "dddd D. MMMM",
  dateFormatDash: "DD-MM-YYYY",
  dateFormatDashWithTime: "DD-MM-YYYY HH:mm",
  dateFormatSlashDayMonth: "DD/MM",
  dateFormatWeekday: "dddd",
  timeFormat: "HH:mm"
};

export const {
  dateFormatCustom,
  dateFormatDayjs,
  dateFormatDefault,
  dateFormatIso,
  dateFormatWeekdayMonth,
  dateFormatDash,
  dateFormatDashWithTime,
  dateFormatSlashDayMonth,
  dateFormatWeekday,
  timeFormat
} = dateFormats;
